module.exports = __webpack_public_path__ + "static/img/2.4a91859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/2.png
// module id = 3B6b
// module chunks = 0